import React, { useState } from 'react'
import { Grid, IconButton, Menu, MenuItem } from '@mui/material'
import { MoreVert, ArrowDownward, ArrowUpward } from '@mui/icons-material'

const iconProps = ({ sortIsActive, isMenu }) => ({
  sx: {
    display: sortIsActive && !isMenu ? 'inline-block' : 'none',
    color: 'text.secondary',
  },
  fontSize: 'small',
})

/**
 * @deprecated
 * this was built when we used beta release of data-grid-pro5, now we use the stable release which has this functionality built in
 * https://v5.mui.com/x/react-data-grid/sorting/#server-side-sorting
 * see: client/src/components/generic/datagrid/BasicDataGridV2.tsx  for the new implementation
 */
export const generateRenderHeaderFunction =
  (filter, setFilter) =>
  (headerName, fieldName, settings = {}) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const { align = 'left', startAscending = true } = settings
    const currentSortFilter = filter?.sort || {}
    const sortIsActive = currentSortFilter.field === fieldName

    const handleSetFilter = (event, ascending) => {
      event.stopPropagation()
      setAnchorEl(null)
      setFilter({
        ...filter,
        sort: {
          field: fieldName,
          ascending,
        },
      })
    }

    return (
      <Grid
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: align === 'left' ? 'row' : 'row-reverse',
          alignItems: 'center',
          cursor: 'pointer',
          ':hover svg': {
            display: sortIsActive ? 'unset' : 'inline-block',
          },
          ':hover svg:not([data-testid=MoreVertIcon])': {
            opacity: sortIsActive ? 'unset' : 0.5,
          },
        }}
        onClick={event => handleSetFilter(event, sortIsActive ? !currentSortFilter?.ascending : startAscending)}
      >
        <Grid
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: align === 'left' ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
          className="MuiDataGrid-columnHeaderTitle"
        >
          <Grid
            sx={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {headerName}
          </Grid>
          <IconButton size="small">
            {((sortIsActive && currentSortFilter.ascending === true) || (!sortIsActive && startAscending === true)) && (
              <ArrowUpward {...iconProps({ sortIsActive })} />
            )}
            {((sortIsActive && currentSortFilter.ascending === false) ||
              (!sortIsActive && startAscending === false)) && <ArrowDownward {...iconProps({ sortIsActive })} />}
          </IconButton>
        </Grid>
        <IconButton
          id={`${fieldName}-menu-button`}
          size="small"
          onClick={event => {
            event.stopPropagation()
            setAnchorEl(event.currentTarget)
          }}
        >
          <MoreVert {...iconProps({ sortIsActive, isMenu: true })} />
        </IconButton>
        <Menu
          id={`${fieldName}-menu`}
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClick={event => event.stopPropagation()}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            'aria-labelledby': `${fieldName}-menu-button`,
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: align === 'left' ? 'right' : 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: align === 'left' ? 'right' : 'left',
          }}
        >
          <MenuItem
            disabled={sortIsActive && currentSortFilter.ascending}
            onClick={event => handleSetFilter(event, true)}
          >
            Sort by ASC
          </MenuItem>
          <MenuItem
            disabled={sortIsActive && !currentSortFilter.ascending}
            onClick={event => handleSetFilter(event, false)}
          >
            Sort by DESC
          </MenuItem>
        </Menu>
      </Grid>
    )
  }
